import { createApp } from 'vue'
import { Constants } from '@/cfg/constants'
import App from './App.vue'
import router from './router'
import store from './store'
import vue3GoogleLogin from 'vue3-google-login'
import VueClickAway from "vue3-click-away"
import CustomScrollbar from 'custom-vue-scrollbar'
import 'custom-vue-scrollbar/dist/style.css'
import YouTube from 'vue3-youtube'
import { i18n, regionI18n } from '@/plugins/i18n'
import VueDeviceDetect from '@basitcodeenv/vue3-device-detect'
import isMobile from '@/plugins/isMobile'

// @ts-ignore
import Toast from '@/plugins/toast'
// @ts-ignore
import Dialog from '@/plugins/dialog'

import "@/directives/tooltip/tooltip.scss"
import "@/assets/scss/design.scss"
import "@/assets/css/fonts.css"
import 'shepherd.js/dist/css/shepherd.css'
import '@/assets/scss/tailwind.scss'
import '@/assets/scss/styles.scss'
import 'vue-final-modal/style.css'

import { createVfm } from 'vue-final-modal'
import VueMitter from '@nguyenshort/vue3-mitt'
import Notifications from 'notiwind'
import { createAuth0 } from '@auth0/auth0-vue'
import ForumAuth from '@/plugins/forumAuth'
import LaunchDarkly from '@/plugins/launchDarkly'

const normalizeLocale = (locale?: string) => {
    if (!locale) return 'en'
    return locale.split('-')[0]
}

const app = createApp(App)

app
    .use(store)
    .use(router)
    .use(createVfm())
    .use(VueMitter)
    .use(i18n)
    .use(regionI18n)
    .use(VueDeviceDetect)
    .use(vue3GoogleLogin, {
        clientId: '586530322371-ksrjhqmenvgoilene4e02o2uflslf8r6.apps.googleusercontent.com'
    })
    .use(VueClickAway)
    .use(Notifications)
    .use(isMobile)
    .use(Toast)
    .use(Dialog)
    .use(createAuth0({
        domain: Constants.AUTH0_DOMAIN,
        clientId: Constants.AUTH0_CLIENT_ID,
        authorizationParams: {
            redirect_uri: window.location.origin,
            ui_locales: normalizeLocale(i18n.global.locale.value),
            audience: Constants.AUTH0_AUDIENCE,
            scope: 'openid profile email offline_access'
        },
        cacheLocation: 'localstorage',
        useRefreshTokens: true,
    }))
    .use(ForumAuth, {
        store,
        router,
        i18n
    })
    .use(LaunchDarkly)
    .component(CustomScrollbar.name, CustomScrollbar)
    .component('YouTube', YouTube)

app.mount('#app')